import { gql, useLazyQuery } from '@apollo/client'
import { useNavigate } from 'react-router-dom'

import { useSites } from 'store'

const OPERATION_ACCOUNT_HIERARCHIES = gql`
  query AccountHierarchies($sf_id: ID!) {
    accounts: accountHierarchies(sf_id: $sf_id) {
      id
      sf_id
      sf_parent_id
      name
      nb_children
      hierarchie
      is_site
      state
    }
  }
`

const useFocus = () => {
  const [{treeRef}] = useSites()
  const navigate = useNavigate()
  const [callAccountHierarchies, {loading}] = useLazyQuery(OPERATION_ACCOUNT_HIERARCHIES)

  const onFocus = async (sfId) => {
    const { data: { accounts } } = await callAccountHierarchies({
      variables: { sf_id: sfId }
    })
    // @ts-expect-error unknown
    treeRef.reset(accounts)
    navigate(`/monitoring/map/${sfId}/redirect_first_floor`)
  }

  return {
    onFocus,
    loading
  }
}

export default useFocus